var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDirectionsManeuverFerryTrain = function SvgDirectionsManeuverFerryTrain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    vectorEffect: "non-scaling-stroke",
    width: 10.039,
    height: 10.039,
    x: 15.673,
    y: 15,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M15.673 21.693h10.04m-8.367 3.346-2.509 2.51m9.202-2.51 2.51 2.51m.164-18.405-2.51 2.51-2.51-2.51"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M20.856 4.96a3.346 3.346 0 0 1 3.347 3.347v3.347M4.124 19.183l2.51-2.51 2.51 2.51"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M9.98 23.366a3.346 3.346 0 0 1-3.346-3.346v-3.347m-1.588-4.877L2.451 7.47H17.51l-2.596 4.326m-.751-4.326H5.797l.837-3.346h6.693zm-2.509-3.346V2.451"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M17.51 12.49a4.85 4.85 0 0 1-3.765-1.673A4.85 4.85 0 0 1 9.98 12.49a4.85 4.85 0 0 1-3.765-1.673 4.85 4.85 0 0 1-3.764 1.673"
  }))));
};
export default SvgDirectionsManeuverFerryTrain;